import React, { useState } from "react";
import "./Auth.scss";
import Login from "./Login";
import OTPScreen from "./OTPScreen";
const Auth = () => {
  const [loginStep, setLoginStep] = useState("login");
   const [input, setInput] = useState({ mobile: '' })
  // console.log("login", loginStep);
  return (
    <div className="auth login">
      <div className="container">
        <div className="auth-container">
          <div className="content">
            <h3>Monitor Your Power Consumption in Real Time</h3>
            <p>
              Track live energy generation & consumption View system efficiency
              & performance trends{" "}
            </p>
          </div>
          {loginStep === "login" && (
            <Login {...{ setLoginStep,input,setInput }} />
          )}

          {loginStep === "otp" && (
            <OTPScreen {...{ setLoginStep,input, }} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Auth;
